import chains from "@shared/src/config/chains";
import { http, type Chain } from "viem";
import { cookieStorage, createConfig, createStorage, fallback, type Config } from "wagmi";
import { walletConnect, baseAccount } from "wagmi/connectors";

// Set up metadata

// Create the modal

// Get projectId from environment variable
const projectId = process.env.NEXT_PUBLIC_WEB3_PROJECT_ID;

if (!projectId) {
  console.trace("Project ID is not defined. WalletConnect will be disabled.");
}

if (chains.length === 0) {
  throw new Error("At least one chain must be configured");
}

export const networks = chains;
export const metadata = {
  name: "iExchange",
  description: "iExchange - offramp and onramp with ease",
  url: typeof window !== "undefined" ? window?.location?.origin || "http://localhost:3000" : "http://localhost:3000",
  icons: [],
};

// Set up the Wagmi Adapter (Config)
export const wconfig: Config = createConfig({
  storage: createStorage({
    storage: cookieStorage,
  }),
  // multiInjectedProviderDiscovery: false,
  // chains: appkitChains,
  chains: [chains[0], ...chains.slice(1)],
  connectors: [
    ...(projectId
      ? [
          walletConnect({
            projectId,
            showQrModal: true,
            qrModalOptions: {
              themeMode: "dark",
            },
          }),
        ]
      : []),
    baseAccount({
      appName: "Base App",
    }),
  ],
  ssr: true,
  transports: chains.reduce((acc, chain) => {
    acc[chain.id] = fallback([http(), http(chain.rpcUrls.fallback?.http?.[0])]);
    return acc;
  }, {} as Record<number, any>),
});

export const wagmiConfig: Config = wconfig;
